var subscribe = function subscribe(subscriber) {
  document.addEventListener("show-global-alert", subscriber);
};
var unsubscribe = function unsubscribe(subscriber) {
  document.removeEventListener("show-global-alert", subscriber);
};
var callAlert = function callAlert(appearance) {
  return function (text, timeout) {
    var alert = {
      message: text,
      timeout: timeout,
      appearance: appearance
    };
    var event = document.createEvent("CustomEvent");
    event.initCustomEvent("show-global-alert", true, true, {
      alert: alert
    });
    document.dispatchEvent(event);
  };
};
export default {
  subscribe: subscribe,
  unsubscribe: unsubscribe,
  success: callAlert("success"),
  info: callAlert("info"),
  warning: callAlert("warning"),
  critical: callAlert("critical")
};